import React, { Component } from 'react';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { t } from '../../../../../locales';
import { isApp } from '../../../../../utils/';
import DashboardCardScenario from '../index';
import img from '../../../../../assets/images/vhis/dashboard/ico-key@3x.png';

interface ScenarioGrantAccessProps {}

class ScenarioGrantAccess extends Component<ScenarioGrantAccessProps> {
  render() {
    const props = {
      imageIcon: img,
      text: t('AXA_GOAL_SCENAVIO_GRANT_ACCESS_TEXT'),
      buttonText: t('AXA_GOAL_SCENAVIO_GRANT_ACCESS_BUTTON_TEXT'),
      clickButton: () => {
        const link = isApp()
          ? 'emma-customer-profile/insured-access'
          : 'emma-customer-profile/insuredaccess';
        EmmaFactory.createInstance().then((e) => {
          e.instance && e.instance.goTo && e.instance.goTo(link);
        });
      },
    };
    return <DashboardCardScenario {...props} />;
  }
}

export default ScenarioGrantAccess;
